/* istanbul ignore next */
export const isNode = () => {
  return typeof process !== 'undefined' && process.release?.name;
};

/* istanbul ignore next */
export const isBrowser = () => {
  return typeof window !== 'undefined';
};
